import React from 'react'
import { connect } from 'react-redux'
import { Page, NewsPageContent } from '../src/ui'
import initialState from '../src/modules/redux/initialState'
import { deepCopy } from '../src/utils'
import PropTypes from 'prop-types'
import {
  TermsOfService,
  Contact,
  PrivacyPolicy,
  ConsumerRights,
  SecureShopping,
  Marketing,
  Help
} from 'src/modules/staticInfo'
import config from 'SRC/config/config.yaml'

class Static extends React.Component {
  static async getInitialProps ({ store, req, query, asPath }) {
    let title
    let component = null

    const key = req && req.originalUrl ? req.originalUrl : (req && req.url) || query.url || asPath || ''

    const path = config.pages.static.paths[key]
    title = path.title
    component = path.component

    return {
      title,
      component,
      state: Static.getPageState(store)
    }
  }

  static getPageState (store) {
    const state = deepCopy(initialState)
    if (store) {
      const currentState = store.getState()

      state.user.auth.isAuthorized = currentState.user.auth.isAuthorized
      state.user.profile.error = currentState.user.profile.error
      state.user.profile.info = currentState.user.profile.info
      state.user.profile.favouriteAds = currentState.user.profile.favouriteAds
      state.user.profile.savedFilters = currentState.user.profile.savedFilters
      state.user.profile.favouriteProfiles = currentState.user.profile.favouriteProfiles
      state.user.listSidebar = currentState.user.listSidebar

      state.common.transitions = currentState.common.transitions
      state.common.router = currentState.common.router
      state.common.is404 = false
      state.common.userTypes = currentState.common.userTypes
      state.common.selectableUserTypes = currentState.common.selectableUserTypes
      state.common.isMobileDevice = currentState.common.isMobileDevice
      state.common.pageMetaTags = currentState.common.pageMetaTags
      state.common.pageMetaTagsSingle = currentState.common.pageMetaTagsSingle

      state.geoObjects.countries = currentState.geoObjects.countries
      state.geoObjects.regions = currentState.geoObjects.regions
      state.geoObjects.cities = currentState.geoObjects.cities

      state.groups = currentState.groups

      state.categories = currentState.categories

      state.ads.sms = currentState.ads.sms

      state.form = currentState.form

      state.cart = currentState.cart
      state.orders = currentState.orders
    }
    return state
  }

  render () {
    const { title, component } = this.props
    const forApp = ['termsofserviceapp', 'privacypolicyapp', 'consumerrightsapp', 'secureshoppingapp', 'helpapp'].includes(component)

    return (
      <Page>
        <NewsPageContent title={title} showHeadingTitle={!forApp}>
          {component === 'termsofservice' || component === 'termsofserviceapp' ? <TermsOfService /> : null}
          {component === 'privacypolicy' || component === 'privacypolicyapp' || component === 'uslovi_koriscenja'
            ? <PrivacyPolicy /> : null}
          {component === 'contact' ? <Contact /> : null}
          {component === 'consumerrights' || component === 'consumerrightsapp' ? <ConsumerRights /> : null}
          {component === 'secureshopping' || component === 'secureshoppingapp' ? <SecureShopping /> : null}
          {component === 'marketing' || component === 'marketingapp' ? <Marketing /> : null}
          {component === 'help' || component === 'helpapp' ? <Help /> : null}
        </NewsPageContent>
      </Page>
    )
  }
}

Static.propTypes = {
  title: PropTypes.string.isRequired,
  component: PropTypes.string.isRequired
}

export default connect(null)(Static)
